import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AgencyData } from '../Types/Agency/AgencyData';
import { TicketStatisticsResponse } from '../Models/ticket-statistics.model';
import { GenericAgencyService } from './generic-agency.service';
import { GenericReservationService } from './generic-reservation.service';

@Injectable({
  providedIn: 'root',
})
export class AgencyServiceService {
  constructor(
    private genericAgencyService: GenericAgencyService,
    private genericReservationService: GenericReservationService,
  ) {}

  getAgencies(): Observable<AgencyData | AgencyData[]> {
    return this.genericAgencyService.Get<AgencyData | AgencyData[]>('agencies');
  }
  getAllAgencies(): Observable<any> {
    return this.genericAgencyService.Get<any>(`agents/data`);
  }

  getAgencyDetails(): Observable<any> {
    return this.genericAgencyService.Get<any>('agencies/data');
  }

  getAgencyAssociatedAgents(params?: any): Observable<any> {
    return this.genericAgencyService.GetWithFilters<any>(
      'agencies/agents',
      params,
    );
  }

  getAgencyAssociatedAgencies(params?: any): Observable<any> {
    return this.genericAgencyService.GetWithFilters<any>(
      'agencies/related-agencies',
      params,
    );
  }

  getAssociatedAgencyAgents(id: string, params?: any): Observable<any> {
    return this.genericAgencyService.GetWithFilters<any>(
      `agencies/${id}/agents`,
      params,
    );
  }

  getAgencyAssociatedAgentsById(
    agencyId: string,
    params?: any,
  ): Observable<any> {
    return this.genericAgencyService.GetWithFilters<any>(
      `agencies/${agencyId}/agents`,
      params,
    );
  }

  getAgencyAssociatedAgenciesById(
    agencyId: string,
    params?: any,
  ): Observable<any> {
    return this.genericAgencyService.GetWithFilters<any>(
      `agencies/${agencyId}/related-agencies`,
      params,
    );
  }

  getAgencyByAccessToken(): Observable<any> {
    return this.genericAgencyService.Get<any>(`agents/data`);
  }

  getAgencyById(id: any): Observable<any> {
    return this.genericAgencyService.Get<any>(`agencies/${id}`);
  }

  getAgencyDescendants(agencyId: string): Observable<any[]> {
    return this.genericAgencyService.Get<any[]>(
      `agencies/${agencyId}/descendants`,
    );
  }

  getAgencyByCognitoId(id: any): Observable<any> {
    return this.genericAgencyService.Get<any>(`agency/getByCognitoId/${id}`);
  }

  getAllRootAgencies(): Observable<any> {
    return this.genericAgencyService.Get<any>(`agencies/root-agencies`);
  }

  AddnewAgency(agency: AgencyData): Observable<any> {
    return this.genericAgencyService.Post<any>(`agencies`, agency);
  }

  AddAgencyMember(user: any, rootManager: string = ''): Observable<any> {
    return this.genericAgencyService.PostUser<any>(
      `users/signup${rootManager}`,
      user,
    );
  }

  UpdateAgency(agency: any): Observable<any> {
    return this.genericAgencyService.Put<any>(`agencies/${agency.id}`, agency);
  }

  //////////////////////////////////////////////////////////////////////////////////

  getAgencyTransactions(agencyId: string, params?: any) {
    return this.genericAgencyService.GetWithFilters(
      `agencies/${agencyId}/transactions`,
      params,
    );
  }
  ///////////////////////////////////////////////////////////////////////////////////
  getTicketStatistics(agencyId: string) {
    return this.genericReservationService.Get<TicketStatisticsResponse>(
      `statistics/tickets?agencyId=${agencyId}`,
    );
  }
  ///////////////////////////////////////////////////////////////////////////////////
  getDashboard(params?: any): Observable<any> {
    return this.genericAgencyService.GetWithFilters<any>(
      'agencies/dashboard',
      params,
    );
  }
}
